import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Callout, Checkbox, ChoiceGroup, DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, FontWeights, Icon, mergeStyleSets, Panel, PanelType, PrimaryButton, Text } from '@fluentui/react';
import { useGetPartieDiRevisionObject } from '../../../hooks/services/sPay/useOfEdPPrepare';
import { useDispatch, useSelector } from 'react-redux';
import { __MessageTypes, enum_ENUM_TIPO_RESPUESTA } from '../../../common/Dictionaries';
import CTextAreaSimple from '../../../components/Common/CTextAreaSimple';
import { isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';
import CValidator from '../../../components/Common/CValidator';
import { setRevisionEdPv2 } from '../../../services/sPay/edpConfig.service';
import { t } from 'i18next';
import MessageBoxInfoComplex from '../../../components/Common/Message/MessageBoxInfoComplex';
import { action_updateEdPPrepareForceGetButtons, action_updateEdPPrepareForceGetHeader, action_updateEdPPrepareForceGetResult } from '../../../reducers/actions/PAY/edpPrepareActions';
import Loading from '../../../components/Templates/Site/Loading';
import { cloneDeep } from 'lodash-es';
import CLabel from '../../../components/Common/CLabel';
import { useBoolean } from '@fluentui/react-hooks';

const ApprovePartieDiPanel = (props) => {
    const dispatch = useDispatch();

    const { 
        inputParam_ElementId = null,
        inputParam_EdPId = null,
        inputParam_IsPanelOpen = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DialogTitleText = '',
        inputParam_VerRevision = false,
        inputParam_SetCalloutVisibleIndex = null,
        inputParam_RolTipoRespuestaId = null,
        inputParam_RolMatrizEtapaFlujo = null,
        inputParam_EstadoPagoPartidaId = null,
        inputParam_PartidaId = null,
        inputParam_EstadoPagoCompuestaDiId = "0",
        inputParam_Iteracion = null,
        inputParam_RefreshPage = false,
        inputParam_EditMode = false,

        inputParam_EdpIatrizEtapaId = null,
        inputParam_TipoRespuestaId = null,
    } = props;

    const {
        _edpPrepareParties: edpPrepareParties,
        _edpPrepareDIs: edpPrepareDIs,
        _edpPrepareHeader: edpPrepareHeader,
        _edpPrepareResult: edpPrepareResult,
    } = useSelector((state) => state.edpPreparationState);

    const callOutStyles = mergeStyleSets({
        button: {
            width: 130,
        },
        callout: {
            width: 500,
            maxWidth: '90%',
            padding: '20px 24px',
        },
        title: {
            marginBottom: 12,
            fontWeight: FontWeights.semilight,
        },
        link: {
            display: 'block',
            marginTop: 20,
        },
    });

    const options = [
        { key: 1, text: t('data-lang-lbl-yes'), onRenderLabel: (option) => (<Icon styles={{root: {fontSize: "19px", top: "-3px", right: "-50px", position: "absolute", color: "green", fontWeight: "bolder"}}} iconName="ActivateOrders" />) },
        { key: 0, text: t('data-lang-lbl-no'), onRenderLabel: (option) => (<Icon styles={{root: {fontSize: "19px", top: "-3px", right: "-50px", position: "absolute", color: "red",   fontWeight: "bolder"}}} iconName="DeactivateOrders" />) },
    ];

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [objFormIsValid, setObjFormIsValid] = useState({
        aprobacion: true,
        comment: true,
        rejectComments: true,
    });

    const [objPartidaRevisionList, setObjPartidaRevisionList] = useState([]);
    const [objDIRevisionList, setObjDIRevisionList] = useState([]);
    
    const [labelComentarioMotivo, setLabelComentarioMotivo] = useState(t('data-lang-lbl-commentreason'));
    const [showBtnAccept, setShowBtnAccept] = useState(true);
    const [messageAlert, setMessageAlert] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    
    const [showAceptButton, setShowAceptButton] = useState(true);
    const [actionInProgress, setActionInProgress] = useState(false);

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [objRevision, setObjRevision] = useState({id: null, aprobado: null, observacion: null, justificacion: null});
    useGetPartieDiRevisionObject(inputParam_IsPanelOpen, inputParam_ElementId, inputParam_EdPId, inputParam_RolTipoRespuestaId, inputParam_PartidaId, inputParam_EstadoPagoCompuestaDiId, inputParam_Iteracion, objRevision, setObjRevision, inputParam_EdpIatrizEtapaId, inputParam_TipoRespuestaId)

    const onChangeRevisionSelectedOption = (ev, option) => {
        setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, aprobacion : true }));

        setObjRevision && setObjRevision(prevState => ({
            ...prevState,
            aprobado : (option.key === 1 ? true : false),
        }));

        Cambiar_Modo_Aprobacion_Rechazo((option.key === 1 ? true : false))

        setObjPartidaRevisionList([]);
        setObjDIRevisionList([]);
    };

    const setterApproveComment = (e) => {
        const { value } = e.currentTarget;

        if (objRevision.aprobado) {
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(value) }));
        }
        else {
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(value) }));
        }

        setObjRevision && setObjRevision(prevState => ({
            ...prevState,
            observacion: objRevision.aprobado === true ? value : null,
            justificacion: objRevision.aprobado === false ? value : null,
        }));
    }

    const onCheckboxPartyChanged = (ev, checked, partidaId, partidaEdPId) => {
        const aux_objPartidaRevisionList = cloneDeep(objPartidaRevisionList)
        if (checked) {
            aux_objPartidaRevisionList.push({id: partidaId, comment: '', isValid: null, partidaEdpId: partidaEdPId})
            setObjPartidaRevisionList && setObjPartidaRevisionList(aux_objPartidaRevisionList);
        }
        else {
            setObjPartidaRevisionList && setObjPartidaRevisionList(objPartidaRevisionList.filter(x => x.id !== partidaId));
        }
    };

    const onCheckboxDIChanged = (ev, checked, partidaId) => {
        const aux_objDIRevisionList = cloneDeep(objDIRevisionList)
        if (checked) {
            aux_objDIRevisionList.push({id: partidaId, comment: '', isValid: null})
            setObjDIRevisionList && setObjDIRevisionList(aux_objDIRevisionList);
        }
        else {
            setObjDIRevisionList && setObjDIRevisionList(objDIRevisionList.filter(x => x.id !== partidaId));
        }
    };

    const setterApproveDICommentList = (control, field) => {
        const diId = field.split('_')[0];
        const aux_objDIRevisionList = cloneDeep(objDIRevisionList)

        aux_objDIRevisionList.forEach(element => {
            if (diId === element.id) {
                element.comment = control.target.value;
                element.isValid = !isNullUndefinedOrEmpty(control.target.value);
            }
        });

        setObjDIRevisionList && setObjDIRevisionList(aux_objDIRevisionList);
    }

    const setterApprovePartieCommentList = (control, field) => {
        const partidaId = field.split('_')[0];
        const aux_objPartidaRevisionList = cloneDeep(objPartidaRevisionList)

        aux_objPartidaRevisionList.forEach(element => {
            if (parseInt(partidaId) === element.id) {
                element.comment = control.target.value
                element.isValid = !isNullUndefinedOrEmpty(control.target.value);
            }
        });

        setObjPartidaRevisionList && setObjPartidaRevisionList(aux_objPartidaRevisionList);
    }

    const validateObject = () => {
        let isValid = true;

        isValid = isValid === true ? !(objRevision.aprobado !== true && objRevision.aprobado !== false) : isValid;
        setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, aprobacion : !(objRevision.aprobado !== true && objRevision.aprobado !== false) }));

        if (objRevision.aprobado) {
            isValid = isValid === true ? !isNullUndefinedOrEmpty(objRevision.observacion) : isValid;
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(objRevision.observacion) }));
        }
        else {
            isValid = isValid === true ? !isNullUndefinedOrEmpty(objRevision.justificacion) : isValid;
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(objRevision.justificacion) }));
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, rejectComments : objPartidaRevisionList.some(x => isNullUndefinedOrEmpty(x.comment)) }));
        }

        return isValid
    }

    const prepareObjetToSave = () => {

        const aux_objPartidaRevisionList = objPartidaRevisionList.length > 0 ? objPartidaRevisionList.map(x => ({partida_id: x.partidaEdpId, di_id: null, justificacion: x.comment})) : [];
        const aux_objDIRevisionList = objDIRevisionList.length > 0 ? objDIRevisionList.map(x => ({partida_id: null, di_id: x.id, justificacion: x.comment})) : [];

        const aux_objRevisionList = [
            ...aux_objPartidaRevisionList,
            ...aux_objDIRevisionList
        ];

        const objtToSave =
        {
            element_id: inputParam_ElementId,
            edp_id: inputParam_EdPId,
            partida_id: inputParam_PartidaId,
            di_id: inputParam_EstadoPagoCompuestaDiId !== "0" ? inputParam_EstadoPagoCompuestaDiId : null,
            rol: inputParam_RolTipoRespuestaId,
            aprobar: objRevision.aprobado,
            item_respuesta_interna: {
                id: 0,
                tipoRespuestaId: inputParam_RolTipoRespuestaId,
                edpMatrizEtapaId: inputParam_RolMatrizEtapaFlujo,
                estadoPagoId: inputParam_EdPId,
                observacion: objRevision.aprobado === true ? objRevision.observacion : null,
                justificacion: objRevision.aprobado === false ? objRevision.justificacion : null,
                fechaRespuesta: new Date(),
                aprobado: objRevision.aprobado,
                estadoPagoPartidaId: inputParam_EstadoPagoPartidaId,
                estadoPagoCompuestaDiId: inputParam_EstadoPagoCompuestaDiId !== "0" ? inputParam_EstadoPagoCompuestaDiId : null,
                iteracion: inputParam_Iteracion,
                fechasCicloId: 0,
                responsableLogin: null,
                codContrato: null,
                fechaRevision: null
            },
            l_partida_di_id_rechazadas: aux_objRevisionList
        }

        return objtToSave;
    }

    const onAprove = async () => {
        setActionInProgress(true);
        if (validateObject()) {
            const objectToSave = prepareObjetToSave()
            await setRevisionEdPv2(objectToSave).then(async (response) => {
                if (response.data.succeeded) {
                    if (response.data.data.result) {  
                        if (inputParam_RefreshPage) {
                            window.location.href = window.location.href
                        }
                        else {
                            dispatch(action_updateEdPPrepareForceGetHeader(true));
                            dispatch(action_updateEdPPrepareForceGetResult(true));
                            dispatch(action_updateEdPPrepareForceGetButtons(true));
                            setShowAceptButton(false);
                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                        }
                    }
                    else {
                        if (response.data.data.l_validations.length > 0) {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_validations)
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        }
                    }

                    setActionInProgress(false);
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setActionInProgress(false);
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setActionInProgress(false);
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'))
            setActionInProgress(false);
        }
    };

    const onClose = async () => {
        setShowAceptButton(true);
        inputParam_SetCalloutVisibleIndex && inputParam_SetCalloutVisibleIndex(null);
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false);
        setActionInProgress(false);
    }
    
    const Cambiar_Modo_Aprobacion_Rechazo = (objRevisionAprobado) => {
        let _message = {
            message : "",
            messageType : __MessageTypes.WARNING,
            showMessage : false,
        };
        let aprobacion_inmediata = ((edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.AEC || edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.AAD || edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ATO) ? false : true);

        if (objRevisionAprobado === true)
        {
            if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.AAD || edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ATO)
            {
                _message.message = t('data-lang-msg-aproveedppartiewaring');
                _message.showMessage = true;
            }

            if (aprobacion_inmediata)
            {
                if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ADN)
                {
                    _message.message = t('data-lang-msg-aproveedpwaring');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA1)
                {
                    _message.message = t('data-lang-msg-aproveedpwaring');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA2)
                {
                    _message.message = t('data-lang-msg-aproveedpwaring');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA3)
                {
                    _message.message = t('data-lang-msg-aproveedpwaring');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ICC)
                {
                    _message.message = t('data-lang-msg-aproveedpwaring');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.LCC)
                {
                    _message.message = t('data-lang-msg-aproveedpwaring');
                    _message.showMessage = true;
                }
            }

            setLabelComentarioMotivo(t('data-lang-lbl-comment'));
            setShowBtnAccept(true);
        }
        else if (objRevisionAprobado === false)
        {
            if (aprobacion_inmediata)
            {
                if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ADN)
                {
                    _message.message = t('data-lang-msg-selectandaddcommentstoitemsincreasedeductionrejected');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA1)
                {
                    _message.message = t('data-lang-msg-selectandaddcommentstoitemsincreasedeductionrejected');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA2)
                {
                    _message.message = t('data-lang-msg-selectandaddcommentstoitemsincreasedeductionrejected');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA3)
                {
                    _message.message = t('data-lang-msg-selectandaddcommentstoitemsincreasedeductionrejected');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ICC)
                {
                    _message.message = t('data-lang-msg-selectandaddcommentstoitemsincreasedeductionrejected');
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.LCC)
                {
                    _message.message = t('data-lang-msg-selectandaddcommentstoitemsincreasedeductionrejected');
                    _message.showMessage = true;
                }
            }

            setLabelComentarioMotivo(t('data-lang-lbl-reason2'));
            setShowBtnAccept(true);
        }
        else
        {
            setLabelComentarioMotivo(t('data-lang-lbl-commentreason'));
            setShowBtnAccept(false);
        }

        setMessageAlert(_message)
    }

    const onDismissPanel = () => {
        setShowAceptButton(true)
        showMessage(setMessageConfig, false, null, null)
        inputParam_SetCalloutVisibleIndex && inputParam_SetCalloutVisibleIndex(null);
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
    };

    const preValidateAction = () => {
        if (validateObject()) {
            if (objRevision.aprobado === false) {
                showDialog();
            }
            else {
                onAprove();
            }
        }
    }

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <Row>
                            <Col xl={12} className="message-verybottom-panel-medium">
                                <MessageBoxInfoComplex
                                    inputParam_Message={ messageConfig.message }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                    inputParam_ShowClose={true}
                                />
                            </Col>
                            {
                                messageAlert.showMessage &&
                                <Col xl={12} className="message-verybottom-panel-medium">
                                    <MessageBoxInfoComplex
                                        inputParam_Message={ messageAlert.message }
                                        inputParam_Display={ messageAlert.showMessage }
                                        inputParam_MessageType={ messageAlert.messageType }
                                        inputParam_SetterMessage={ null }
                                        inputParam_ShowClose={false}
                                    />
                                </Col>
                            }
                        </Row>
                    </Col>
                    <Col xl={12}>
                        <Row className='mt-3'>
                            <Col className='d-flex'>
                                {
                                    !actionInProgress &&
                                    <>
                                        {
                                            showBtnAccept && showAceptButton && inputParam_EditMode && !inputParam_VerRevision &&
                                            <PrimaryButton className='mx-1' text={t('data-lang-btn-acept')} onClick={ preValidateAction } />
                                        }
                                        <DefaultButton className='mx-1' text={ !inputParam_VerRevision && inputParam_EditMode ? t('data-lang-btn-cancelclose') : t('data-lang-btn-close')} onClick={onClose} />
                                    </>
                                }
                                {
                                    actionInProgress &&
                                    <Loading
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={true}
                                        inputParam_Text={t('data-lang-lbl-executing')}
                                        inputParam_Position="unset"
                                        inputParam_Width="20px"
                                        inputParam_Height="20px"
                                        inputParam_Vertical={false}
                                        inputParam_ColClassName="my-auto"
                                        inputParam_EjecutingTextClass={"ps-4"}
                                        inputParam_Left="87%"
                                        inputParam_Top="11px"
                                        inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                    />
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={  `${t('data-lang-boxname-edpconfig-edpapproval')}${!isNullUndefinedOrEmpty(inputParam_DialogTitleText)?`: ${inputParam_DialogTitleText}`:''}` }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth="900px"
                type={ PanelType.custom }
            >
                {
                    !isNullUndefined(objRevision.id) &&
                    <>
                        <Row className='my-3'>
                            <Col xl={4} className='my-auto'><b>{t('data-lang-lbl-aprovereject')}</b></Col>
                            <Col xl={8}>
                                {
                                    !inputParam_VerRevision && objRevision.id !== null &&
                                    <>
                                        <ChoiceGroup
                                            selectedKey={!isNullUndefined(objRevision.aprobado) ? (objRevision.aprobado ? 1 : 0) : undefined}
                                            options={options}
                                            onChange={onChangeRevisionSelectedOption}
                                            required={true}
                                            disabled={!inputParam_EditMode}
                                            styles={{
                                                flexContainer: {
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    gap: "100px"
                                                }
                                            }}
                                        />
                                        <CValidator isInValid={!objFormIsValid.aprobacion} />
                                    </>
                                }
                                { inputParam_VerRevision === true && (objRevision.aprobado ? 'Sí' : 'No') }
                            </Col>
                        </Row>
                        <Row className='my-3'>
                            <Col xl={4}><b>{labelComentarioMotivo}</b></Col>
                            <Col xl={8}>
                                <CTextAreaSimple
                                    rows={10}
                                    maxLength={1000}
                                    showLabel={false}
                                    controlValue={ (objRevision.aprobado ? objRevision.observacion : objRevision.justificacion) } 
                                    textBoxName={'action'}
                                    setterControlValue={setterApproveComment}
                                    editMode={!inputParam_VerRevision && inputParam_EditMode}
                                />
                                {
                                    !inputParam_VerRevision &&
                                    <CValidator isInValid={!objFormIsValid.comment} />
                                }
                            </Col>
                        </Row>
                        {
                            !inputParam_VerRevision && inputParam_EditMode &&
                            <>
                            {
                                objRevision.aprobado === false &&
                                <>
                                    <div className='mt-3'><Text as="h1" block variant="xLarge" className={callOutStyles.title}>{ t('data-lang-lbl-itemsrejected') }</Text></div>
                                    <Row>
                                        <Col>
                                            {
                                                edpPrepareResult && edpPrepareResult.filter(x => (x.id > 0 || x.listadO_PARTIDA_CODIGO.indexOf('#') !== -1) && x.partidA_ID > 0 && x.subpartidA_ID === null).map((partida, index) => {
                                                    const partidaRevision = objPartidaRevisionList.find(x => x.id === partida.partidA_ID);
                                                    return (
                                                        <Card key={partida.partidA_ID} className='my-1'>
                                                            <Card.Body>
                                                                <Row className="row p-0 m-0">
                                                                    <Col className='col-auto me-auto p-0 m-0 pe-1'>
                                                                        <Checkbox className='p-1' checked={!isNullUndefined(partidaRevision)} onChange={(ev, checked) => onCheckboxPartyChanged(ev, checked, partida.partidA_ID, partida.edP_PARTIDA_ID)} />
                                                                    </Col>
                                                                    <Col className='p-0 m-0 ps-1'>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col className='col-auto me-auto p-0 m-0'><b>{t('data-lang-lbl-code')}:&nbsp;</b></Col>
                                                                            <Col className='p-0 m-0'>
                                                                                <div>{edpPrepareParties.find(x => x.partidA_ID === partida.partidA_ID).codigo}</div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col className='col-auto me-auto p-0 m-0'><b>{t('data-lang-lbl-contractpartie-partiename')}:&nbsp;</b></Col>
                                                                            <Col className='p-0 m-0'>
                                                                                <div>{edpPrepareParties.find(x => x.partidA_ID === partida.partidA_ID).nombre}</div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col xl={12} className='p-0 m-0'><b>{t('data-lang-lbl-comment')}</b></Col>
                                                                        </Row>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col xl={12} className='p-0 m-0'>
                                                                                <CTextAreaSimple
                                                                                    rows={10}
                                                                                    maxLength={1000}
                                                                                    showLabel={false}
                                                                                    controlValue={ (!isNullUndefined(partidaRevision) ? partidaRevision.comment : "") } 
                                                                                    textBoxName={'action'}
                                                                                    setterControlValue={setterApprovePartieCommentList}
                                                                                    setterControlIsDynamic={true}
                                                                                    setterField={`${partida.partidA_ID}_comment`}
                                                                                    editMode={!isNullUndefined(partidaRevision)}
                                                                                />
                                                                                {
                                                                                    !isNullUndefined(partidaRevision) && !partidaRevision.isValid &&
                                                                                    <CValidator isInValid={!partidaRevision.isValid } />
                                                                                }
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                    )
                                                })
                                            }
                                            {
                                                edpPrepareParties && edpPrepareParties.length === 0 &&
                                                <Card className='my-1'><Card.Body className='text-center'>{t('data-lang-lbl-nodatatoselect')}</Card.Body></Card>
                                            }
                                        </Col>
                                    </Row>
                                </>
                            }
                            {
                                objRevision.aprobado === false &&
                                <>
                                    <Row>
                                        <Col>
                                            <Row>
                                                <div className='mt-3'><Text as="h1" block variant="xLarge" className={callOutStyles.title}>{ t('data-lang-lbl-increasesrejected') }</Text></div>
                                            </Row>
                                            {
                                                edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO === "ª" && x.dI_ID_COMPUESTA.indexOf('I|') !== -1 && edpPrepareHeader.l_partidas_permiso.some(j => j.dI_ID_COMPUESTA === x.dI_ID_COMPUESTA && j.iconoRevision === 4)).map((item, index) => {
                                                    const diRevision = objDIRevisionList.find(x => x.id === item.dI_ID_COMPUESTA);
                                                    return (
                                                        <Card key={item.partidA_ID} className='my-1'>
                                                            <Card.Body>
                                                                <Row className="row p-0 m-0">
                                                                    <Col className='col-auto me-auto p-0 m-0 pe-1'>
                                                                        <Checkbox className='p-1' checked={!isNullUndefined(diRevision)} onChange={(ev, checked) => onCheckboxDIChanged(ev, checked, item.dI_ID_COMPUESTA)} />
                                                                    </Col>
                                                                    <Col className='p-0 m-0 ps-1'>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col className='col-auto me-auto p-0 m-0'><b>{t('data-lang-lbl-increasename')}:&nbsp;</b></Col>
                                                                            <Col className='p-0 m-0'>
                                                                                <div>{edpPrepareDIs.find(x => x.id === item.edP_INCREMENTO_ID).nombre}</div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col xl={12} className='p-0 m-0'><b>{t('data-lang-lbl-comment')}</b></Col>
                                                                        </Row>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col xl={12} className='p-0 m-0'>
                                                                                <CTextAreaSimple
                                                                                    rows={10}
                                                                                    maxLength={1000}
                                                                                    showLabel={false}
                                                                                    controlValue={ (!isNullUndefined(diRevision) ? diRevision.comment : "") } 
                                                                                    textBoxName={'action'}
                                                                                    setterControlValue={setterApproveDICommentList}
                                                                                    setterControlIsDynamic={true}
                                                                                    setterField={`${item.dI_ID_COMPUESTA}_comment`}
                                                                                    editMode={!isNullUndefined(diRevision)}
                                                                                />
                                                                                {
                                                                                    !isNullUndefined(diRevision) && !diRevision.isValid &&
                                                                                    <CValidator isInValid={!diRevision.isValid } />
                                                                                }
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                    )
                                                })
                                            }
                                            <Row>
                                                <div className='mt-3'><Text as="h1" block variant="xLarge" className={callOutStyles.title}>{ t('data-lang-lbl-deductionsrejected') }</Text></div>
                                            </Row>
                                            {
                                                edpPrepareResult && edpPrepareResult.filter(x => x.listadO_PARTIDA_CODIGO === "ª" && x.dI_ID_COMPUESTA.indexOf('D|') !== -1 && edpPrepareHeader.l_partidas_permiso.some(j => j.dI_ID_COMPUESTA === x.dI_ID_COMPUESTA && j.iconoRevision === 4)).map((item, index) => {
                                                    const diRevision = objDIRevisionList.find(x => x.id === item.dI_ID_COMPUESTA);
                                                    return (
                                                        <Card key={item.partidA_ID} className='my-1'>
                                                            <Card.Body>
                                                                <Row className="row p-0 m-0">
                                                                    <Col className='col-auto me-auto p-0 m-0 pe-1'>
                                                                        <Checkbox className='p-1' checked={!isNullUndefined(diRevision)} onChange={(ev, checked) => onCheckboxDIChanged(ev, checked, item.dI_ID_COMPUESTA)} />
                                                                    </Col>
                                                                    <Col className='p-0 m-0 ps-1'>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col className='col-auto me-auto p-0 m-0'><b>{t('data-lang-lbl-deductionname')}:&nbsp;</b></Col>
                                                                            <Col className='p-0 m-0'>
                                                                                <div>{edpPrepareDIs.find(x => x.id === item.edP_DEDUCCION_ID).nombre}</div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col xl={12} className='p-0 m-0'><b>{t('data-lang-lbl-comment')}</b></Col>
                                                                        </Row>
                                                                        <Row className="row p-0 m-0">
                                                                            <Col xl={12} className='p-0 m-0'>
                                                                                <CTextAreaSimple
                                                                                    rows={10}
                                                                                    maxLength={1000}
                                                                                    showLabel={false}
                                                                                    controlValue={ (!isNullUndefined(diRevision) ? diRevision.comment : "") } 
                                                                                    textBoxName={'action'}
                                                                                    setterControlValue={setterApproveDICommentList}
                                                                                    setterControlIsDynamic={true}
                                                                                    setterField={`${item.dI_ID_COMPUESTA}_comment`}
                                                                                    editMode={!isNullUndefined(diRevision)}
                                                                                />
                                                                                {
                                                                                    !isNullUndefined(diRevision) && !diRevision.isValid &&
                                                                                    <CValidator isInValid={!diRevision.isValid } />
                                                                                }
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                    )
                                                })
                                            }
                                            {
                                                edpPrepareDIs && edpPrepareDIs.length === 0 &&
                                                <Card className='my-1'><Card.Body className='text-center'>{t('data-lang-lbl-nodatatoselect')}</Card.Body></Card>
                                            }
                                        </Col>
                                    </Row>
                                </>
                            }
                            {
                                objRevision.aprobado === false && isDialogVisible === true &&
                                <Dialog
                                    hidden={!isDialogVisible}
                                    onDismiss={hideDialog}
                                    minWidth={740}
                                    maxWidth={1000}
                                    dialogContentProps={{
                                        type: DialogType.normal,
                                        title: t('data-lang-boxname-warning'),
                                    }}
                                    modalProps={{
                                        isBlocking: true,
                                    }}
                                >
                                    <Row>
                                        <Col xs={12} xl={12} className="mt-3">
                                            <CLabel labelValue={ t('data-lang-msg-generaleppartieaprovement') } /><br/>
                                            <CLabel labelValue={ t('data-lang-msg-doyouwishcontinue') } className={'mt-3'} />
                                        </Col>
                                    </Row>
                                    <DialogFooter>
                                        {
                                            !actionInProgress &&
                                            <Row>
                                                <Col></Col>
                                                <Col className='col-auto me-auto'>
                                                    <PrimaryButton onClick={onAprove} text={t('data-lang-lbl-yes')} />
                                                </Col>
                                                <Col className='col-auto me-auto'>
                                                    <DefaultButton onClick={hideDialog} text={t('data-lang-lbl-no')} />
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            actionInProgress &&
                                            <Loading
                                                inputParam_Style={{marginTop: 0}}
                                                inputParam_ShowLoading={true}
                                                inputParam_ShowText={true}
                                                inputParam_Text={t('data-lang-lbl-executing')}
                                                inputParam_Position="unset"
                                                inputParam_Width="20px"
                                                inputParam_Height="20px"
                                                inputParam_Vertical={false}
                                                inputParam_ColClassName="my-auto"
                                                inputParam_EjecutingTextClass={"ps-4"}
                                                inputParam_Left="87%"
                                                inputParam_Top="11px"
                                                inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                            />
                                        }
                                    </DialogFooter>
                                </Dialog>
                            }
                            </>
                        }
                    </>
                }
                {
                    isNullUndefined(objRevision.id) &&
                    <Loading
                        inputParam_Style={{marginLeft: '40%', marginTop: '50%'}}
                        inputParam_ShowLoading={true}
                        inputParam_ShowText={true}
                        inputParam_Text={t('data-lang-lbl-loading')}
                        inputParam_Position="unset"
                        inputParam_Width="20px"
                        inputParam_Height="20px"
                        inputParam_Vertical={false}
                        inputParam_ColClassName="my-auto"
                        inputParam_EjecutingTextClass={"ps-4"}
                        inputParam_Left="87%"
                        inputParam_Top="11px"
                        inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                    />
                }
            </Panel>
        </div>
    );
};

export default ApprovePartieDiPanel;